export default "__VITE_ASSET__CDcqFB1d__"